import i18n from "@/plugins/i18n.js";
const localizationContext = i18n.messages[i18n.fallbackLocale].validation;

// thanks to jago from regex101 :)! | src: https://regex101.com/r/mX1xW0/1
const mailRegex = new RegExp(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i)
export default {
  data: () => {
    return {
      mailRules: [
        (mail) => mailRegex.test(mail) || localizationContext["mail_unvalid"],
      ],
      commonRules: [(rule) => !!rule || localizationContext["input_mayNotBeEmpty"]],
    };
  },
};
